// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de la vista global "Gestió laboral -> Empleats"
   (GestioLaboralEmpleats.js). Totes les classes van prefixades amb
   "gl-empleats-" perquè no afectin cap altra pantalla: per revertir-ho
   n'hi ha prou en eliminar aquest fitxer i el seu import. Mateix patró
   visual (fons gris clar, tipografia compacta) que absencies-emp-filtres i
   baixes-emp-filtres, per coherència dins tot el mòdul de Gestió laboral. */

.gl-empleats-filtres {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  background-color: #f4f4f4;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 10px;
}

.gl-empleats-filtres label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: bold;
  color: #444;
}

.gl-empleats-filtres select,
.gl-empleats-filtres input[type="date"] {
  font-size: 13px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.gl-empleats-cerca {
  margin-bottom: 12px;
}

.gl-empleats-error {
  color: #d9534f;
  font-weight: bold;
}

.gl-empleats-comptadors {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  flex-shrink: 0;
  padding: 10px 14px;
  background-color: var(--dv2-surface, #fff);
  border: 1px solid var(--dv2-border, #cfe0ff);
  border-radius: var(--dv2-radius, 12px);
  box-shadow: var(--dv2-shadow, none);
  font-size: 14px;
}

.gl-empleats-comptador {
  display: flex;
  align-items: center;
  gap: 5px;
}

.gl-empleats-comptador-punt {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}

.gl-empleats-xip {
  display: inline-block;
  font-size: 11px;
  color: #fff;
  padding: 1px 6px;
  border-radius: 10px;
  margin-right: 3px;
  white-space: nowrap;
}

.gl-empleats-hores-pendent {
  color: #d9534f;
  font-weight: bold;
}

.gl-empleats-hores-excedent {
  color: #0099cc;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/gestiolaboralempleats.css"],"names":[],"mappings":"AAAA;;;;;4EAK4E;;AAE5E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,4CAA4C;EAC5C,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* Estils específics de la vista global \"Gestió laboral -> Empleats\"\n   (GestioLaboralEmpleats.js). Totes les classes van prefixades amb\n   \"gl-empleats-\" perquè no afectin cap altra pantalla: per revertir-ho\n   n'hi ha prou en eliminar aquest fitxer i el seu import. Mateix patró\n   visual (fons gris clar, tipografia compacta) que absencies-emp-filtres i\n   baixes-emp-filtres, per coherència dins tot el mòdul de Gestió laboral. */\n\n.gl-empleats-filtres {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n  background-color: #f4f4f4;\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 10px;\n}\n\n.gl-empleats-filtres label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: bold;\n  color: #444;\n}\n\n.gl-empleats-filtres select,\n.gl-empleats-filtres input[type=\"date\"] {\n  font-size: 13px;\n  padding: 4px 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.gl-empleats-cerca {\n  margin-bottom: 12px;\n}\n\n.gl-empleats-error {\n  color: #d9534f;\n  font-weight: bold;\n}\n\n.gl-empleats-comptadors {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  flex-shrink: 0;\n  padding: 10px 14px;\n  background-color: var(--dv2-surface, #fff);\n  border: 1px solid var(--dv2-border, #cfe0ff);\n  border-radius: var(--dv2-radius, 12px);\n  box-shadow: var(--dv2-shadow, none);\n  font-size: 14px;\n}\n\n.gl-empleats-comptador {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.gl-empleats-comptador-punt {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n}\n\n.gl-empleats-xip {\n  display: inline-block;\n  font-size: 11px;\n  color: #fff;\n  padding: 1px 6px;\n  border-radius: 10px;\n  margin-right: 3px;\n  white-space: nowrap;\n}\n\n.gl-empleats-hores-pendent {\n  color: #d9534f;\n  font-weight: bold;\n}\n\n.gl-empleats-hores-excedent {\n  color: #0099cc;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
